import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/settings/appearance")({
  staticData: { title: "Appearance" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/settings/appearance.tsx"),
    "AppearanceSettings",
  ),
})
